import React from 'react';
import Social from './social';
import "./stylesheet/footer.css"
function Footer() {
  return (
  
  
  
  <div className='footerm'>
    {/* footer>>svg,div,div>>social */}
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
    <defs>
    <linearGradient id="radient" x1="7%" y1="75%" x2="93%" y2="25%">
    <stop offset="5%" stop-color="#000428"></stop>
    <stop offset="95%" stop-color="#004E92"></stop>
    </linearGradient>
      </defs>
      <path fill="url(#radient)" fill-opacity="1" d="M0,160L48,170.7C96,181,192,203,288,176C384,149,480,75,576,69.3C672,64,768,128,864,144C960,160,1056,128,1152,128C1248,128,1344,160,1392,176L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>

      {/* <path  fill="url(#radient)" d="M0,96L4,117.3C96,139,192,181,288,197.3C384,213,480,203,576,170.7C672,139,768,85,864,90.7C960,96,1056,160,1152,165.3C1248,171,1344,117,1392,90.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg> */}</svg>
      <div className="insidefooter">
       <Social/>
  <div className="line"></div>
  <div>design by Umang sahu</div>

  </div>
   </div>

   
  )
}

export default Footer